import { useQuery } from "@tanstack/react-query";

import { getProgramEquipments } from "../services/goHireService";
import { ProgramEquipmentCategory } from "../types/programEquipments.types";
import { GO_SERVICE_QUERY_KEYS } from "../queryKeys";

export const useGetProgramEquipments = () => {
  return useQuery<ProgramEquipmentCategory[]>({
    queryKey: GO_SERVICE_QUERY_KEYS.programEquipments(),
    queryFn: getProgramEquipments,
  });
};
